import S from 'pull-stream';
import xtend from 'xtend';
import Model from 'pull-stream-model';
import shouldUpdate from 'pull-stream-model/should-update';
import ReactStream from '@invintus/react-pull-stream';

import queryString from '../../utils/QueryString';
import View from '../../vast/analytics/view/VastAnalytics';
import AnalyticsModel from '../../vast/analytics/model/index';
import Log from '../../lib/log';

/*
{
  "ads": {
      "2017-03-17 00:00:00": [
        {
          "clientID": "1000000000",
          "actionDate": "2017-03-17 00:00:00",
          "campiagnID": "46",
          "assetID": "6ccfafed62f4e0240b9f5a4a8f53aef19a98ecaa",
          "counts": "0",
          "clickCount": null,
          "weight": "5"
        }
      ],
    },
    "assetTotalCounts": {
      "6ccfafed62f4e0240b9f5a4a8f53aef19a98ecaa": 0
    },
    "assetTotalClicks": {
      "6ccfafed62f4e0240b9f5a4a8f53aef19a98ecaa": 0
    },
    "totalCounts": 0,
    "totalClicks": 0
  }
}
*/

function VastAnalyticsRoute (api, socket, opts, match) {
    // @TODO client side routing will pass in the query string
    var qsParams = queryString.parse(window.location.search);
    var vastID = qsParams.id;
    var viewStream = ReactStream(View);
    var model = Model(AnalyticsModel(api));
    var log = Log();

    /*
        if we want to send dynamic arguments (from UI, for example) to the
        API calls, that is like an applicative functor

        the args are a container (functor), an array
        the call is an applicative functor
    */
    // var get = api.vast.campaignStats.bind(api.vast, { campaignID: vastID });

    viewStream.source.push(model.msg.analytics.get({ campaignID: vastID }));
    viewStream.source.push(model.msg.vast.get({ campaignID: vastID }));

    S(
        viewStream,
        model.effects(),
        S.through(function (ev) {
            if (process.env.NODE_ENV !== 'development') return;
            log.push(ev);
        }),
        model.store,
        S.map(function (state) {
            return xtend(state, {
                resolving: state.vast.resolving.length +
                    state.analytics.resolving.length
            });
        }),
        shouldUpdate(function (prev, next) {
            if (!prev) return true;
            return !(prev.resolving && next.resolving);
        }),
        // S.through(console.log.bind(console, 'state')),
        viewStream
    );

    return viewStream.view;
}

export default VastAnalyticsRoute;
